import type {ComponentProps} from '@enonic/react-components'
import type {PageData} from '@enonic/react-components'
import {SiteRegion} from '../primitives'
import * as React from 'react'
import {FrontPage} from '../front-page/FrontPage'
import {NewsLanding} from '../news-landing/NewsLanding'
import {PersonLanding} from '../person-landing/PersonLanding'
import {EducationLanding} from '../education-landing/EducationLanding'

const APP = 'no.diakonova.fagskolen'

const HEADER_MAP: Record<string, React.ComponentType<ComponentProps>> = {
    'portal:site': FrontPage,
    [APP + ':news-landing']: NewsLanding,
    [APP + ':person-landing']: PersonLanding,
    [APP + ':education-landing']: EducationLanding,
}

export const DefaultPage = (props: ComponentProps) => {
    const page = props.component as PageData
    const mainRegion = page.regions?.main
    const data = props.data as Record<string, unknown>
    const contentType = data?.contentType as string

    const HeaderComponent = contentType ? HEADER_MAP[contentType] : undefined

    return (
        <main id="main">
            {HeaderComponent && (
                <HeaderComponent
                    component={props.component}
                    data={data}
                    common={props.common}
                    meta={props.meta}
                />
            )}
            <SiteRegion
                name="main"
                data={mainRegion?.components ?? []}
                meta={props.meta}
                common={props.common}
            />
        </main>
    )
}
